"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapEach = void 0;
var types_1 = require("../types");
var gen_1 = require("./gen");
var mapEach = function (mapP, mapE, mapS) { return function (target) {
    switch (target.status) {
        case types_1.promiseState.pending:
            return (0, gen_1.pending)(mapP(target.value));
        case types_1.promiseState.error:
            return (0, gen_1.error)(mapE(target.value));
        case types_1.promiseState.success:
            return (0, gen_1.success)(mapS(target.value));
    }
}; };
exports.mapEach = mapEach;
